import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TYPES_ALERTS, TYPES_USER_STATUS } from 'utils/constants'
import { useGetUser, usePostResendEmail } from 'hooks/user'
import { getCurrentUserTypeByRole } from 'utils'
import { STATUS_FLAGS } from 'utils/constants/flags'
import useCheckCanary from 'hooks/useCheckCanary'
import PendingTasks from 'app/components/NotificationsTop/Notifications/PendingTasks'
import {
  NoEmailNotification,
  SatisfactionSurveyNotification,
} from 'app/components/NotificationsTop/Notifications'
import ChatIANotification from 'app/components/NotificationsTop/Notifications/ChatIANotification'
import { useSnackBarFeedback } from 'context/snackbarFeedback'

const useNotifications = () => {
  const { t } = useTranslation()
  const addFeedback = useSnackBarFeedback()
  const {
    data: { email, id: userId, notifications, role, status, userFlags },
  } = useGetUser(false)
  const { mutate: mutateResendEmail } = usePostResendEmail()
  const displayChatIAReminder = useCheckCanary(
    window?.chatIA?.canaryUsers,
    window?.chatIA?.showChatIAReminder
  )
  const { pathname } = useLocation()
  const { enableSatisfactionSurvey } = window.satisfactionSurvey || {}
  const { isStudent, isTeacher } = getCurrentUserTypeByRole(role)

  let counter = 0
  const alerts = []
  const isPendingToValidate = status === TYPES_USER_STATUS.PENDING_VERIFY
  const showPendingTasksNotification = isStudent && notifications?.tasks.length
  const showChatIANotification =
    isTeacher &&
    userFlags?.CHATIA_REMINDER === STATUS_FLAGS.TRUE &&
    displayChatIAReminder
  const showSatisfactionSurveyNotification =
    isTeacher &&
    userFlags?.FEEDBACK_POOL_LATER === STATUS_FLAGS.TRUE &&
    enableSatisfactionSurvey

  if (isPendingToValidate) {
    counter++
    const handleSendEmail = () => {
      mutateResendEmail(
        { userId },
        {
          onSuccess: () => {
            addFeedback({
              dataTestId: 'success-feedback-update-grade',
              id: 'success-feedback-update-grade',
              text: t(
                'Te hemos enviado un correo con las indicaciones para verificar tu cuenta Comprueba que está escrito correctamente o que no lo has recibido en la bandeja de spam'
              ),
              variant: TYPES_ALERTS.SUCCESS,
            })
          },
        }
      )
    }
    alerts.push({
      description: (
        <NoEmailNotification
          email={email}
          onPress={handleSendEmail}
          pathname={pathname}
        />
      ),
      variant: 'warning',
    })
  }
  if (showPendingTasksNotification) {
    counter++
    notifications?.tasks.forEach(({ clazz, endDate, taskId, title }) => {
      alerts.push({
        description: (
          <PendingTasks
            clazz={clazz}
            endDate={endDate}
            key={taskId}
            taskId={taskId}
            title={title}
            userId={userId}
          />
        ),
      })
    })
  }
  if (showSatisfactionSurveyNotification) {
    counter++
    alerts.push({
      description: <SatisfactionSurveyNotification />,
    })
  }
  if (showChatIANotification) {
    counter++
    alerts.push({
      dataTestId: 'chatia-alert',
      description: <ChatIANotification />,
      id: 'alert-chatIA-id',
    })
  }

  return { alerts, counter }
}

export default useNotifications
